/** Local presentation/cache identity; never grants server permissions. */
export function ariaConversationScope(user) {
  const permissions = Array.isArray(user?.permissions) ? [...new Set(user.permissions.filter(value => typeof value === 'string'))].sort() : [];
  return JSON.stringify([user?.company_id ?? null, user?.id ?? user?.sub ?? null, user?.effectiveRole ?? user?.role ?? '', permissions]);
}
